const translations = {
  "en": {
    "Connect portfolio": "Connect portfolio",
    "Let me know more about your assets": "Let me know more about your assets",
    "Maybe later": "Maybe later",
    "Other ways": "Other ways",
    "Snap a photo": "Snap a photo",
    "Upload a statement": "Upload a statement"
  },
  "zh-tw": {
    "Connect portfolio": "連接投資組合",
    "Let me know more about your assets": "請告訴我更多關於你的資產。",
    "Maybe later": "暫不",
    "Other ways": "其他方式",
    "Snap a photo": "拍一張照片",
    "Upload a statement": "上傳一份對帳單"
  }
};

export default translations;
